@for(itemSelected of list; track $index){
  @if(itemSelected.selectedTree || itemSelected.selected){
    <div class="field-type-list__container-tree-selected-inner"
      [ngStyle]="{'padding-left': (16*level)+'px'}"
      [ngClass]="{'field-type-list__container-tree-selected-inner--selected': !itemSelected.children?.length}">
      <div class="field-type-list__text-tree-selected">
        @if (!itemSelected.children?.length){
          <div class="common-badge__block-dot-md">
            <div class="common-badge__dot-xs-main-1000"></div>
          </div>
        }
        <span-tooltip [text]="itemSelected.text"></span-tooltip>
      </div>
      @if(itemSelected.children?.length){
        <tree-selected-multiple class="field-type-list__container-tree-selected-multiple"
          [list]="itemSelected.children"
          [level]="nextLevel"></tree-selected-multiple>
      }
    </div>
  }
}
